import { keepPreviousData } from '@tanstack/react-query';
import { bunja } from 'bunja';
import { useBunja } from 'bunja/react';
import { keyBy } from 'es-toolkit';
import { atom, useAtomValue } from 'jotai';
import { atomWithQuery } from 'jotai-tanstack-query';

import { getCurrenciesApi } from '@flipster/apis/v1/currency';
import { currencyV1Instance } from '@flipster/apis/v1/currency/instance';

export const v1CurrenciesBunja = bunja(() => {
  const getCurrenciesApiAtom = atomWithQuery(() => {
    return {
      queryKey: ['getCurrenciesApi', 'v1'],
      queryFn: getCurrenciesApi,
      select: (res) => res.data,
      placeholderData: keepPreviousData,
      retry: 1,
      retryDelay: 1000 * 3,
    };
  });

  const currenciesAtom = atom((get) => {
    const { data } = get(getCurrenciesApiAtom);
    return data?.currencies.map(currencyV1Instance);
  });

  const currenciesKeyByCurrencyAtom = atom((get) => {
    const currencies = get(currenciesAtom);
    return currencies && keyBy(currencies, (v) => v.currency);
  });

  return { getCurrenciesApiAtom, currenciesAtom, currenciesKeyByCurrencyAtom };
});
v1CurrenciesBunja.debugLabel = 'v1CurrenciesBunja';

export function useV1Currencies() {
  const { currenciesAtom, currenciesKeyByCurrencyAtom } = useBunja(v1CurrenciesBunja);
  const currencies = useAtomValue(currenciesAtom);
  const currenciesKeyByCurrency = useAtomValue(currenciesKeyByCurrencyAtom);

  return { currencies, currenciesKeyByCurrency };
}
